/**
 * Shared Axios config for multipart/form-data requests (podcast/episode file uploads).
 */
export const MULTIPART_HEADERS = { headers: { "Content-Type": "multipart/form-data" } }

const OMITTED_EPISODE_KEYS = [
  "logo",
  "logoFile",
  "upload_status",
  "file_url",
  "duration",
  "duration_hms",
  "size",
  "episode_source",
  "transcript_url",
  "transcript_type",
]

/**
 * Build a FormData payload for an episode update/create request.
 * Appends the serialized episode JSON and, if present, a logo file.
 *
 * @param {Object} episode  Episode data object (may include a `logoFile` File).
 * @returns {FormData}
 */
export const buildEpisodeFormData = (episode) => {
  const payload = { ...episode }
  OMITTED_EPISODE_KEYS.forEach((key) => delete payload[key])

  const data = new FormData()
  data.append("episode", JSON.stringify(payload))

  if (episode.logoFile) {
    data.append("logo", episode.logoFile)
  }

  return data
}
